export default "__VITE_ASSET__BdxUFv8P__"